import React from "react";

function PayInfo(props) {
  return (
    <div className="bg-gray-100 py-16 px-6 animate__animated animate__fadeIn mt-10">
      <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-xl p-8 md:p-12 mt-6 sm:mt-10 md:mt-20">
        <h2 className="text-3xl font-semibold mb-4">
          Төлөм ыкмалары
        </h2>
        <p>
          Сиз заказ кылган эмеректериңизди төмөнкү ыкмалар аркылуу төлөсөңүз
          болот:{" "}
        </p>
        <h1 className="text-xl font-semibold mb-4">
          1. Накталай төлөм
        </h1>
        <ul className="list-disc pl-6 mb-4">
          <li>Биздин магазинибизде накталай төлөм жүргүзсөңүз болот.</li>
          <li>
            Төлөмдү эки бөлүк менен жүргүзүү мүмкүн: - Алгач 30% сумманы заказ
            берген күнү төлөйсүз.
          </li>
          <li>Калган сумманы жеткирүү алдында төлөйсүз.</li>
          <li>
            100% төлөм кабыл алынгандан кийин, жеткирүү күнү жана убактысы
            макулдашылат.
          </li>
        </ul>
        <h1 className="text-xl font-semibold">
          2. Банк аркылуу которуу
        </h1>
        <ul className="list-disc pl-6 mb-4">
          <li>
            КРдеги каалаган банк аркылуу төлөм жүргүзө аласыз. Бул ыкма коопсуз
            жана ыңгайлуу. .
          </li>
        </ul>
        <div className="mb-6">
          <h3 className="text-xl font-semibold ">
            Заказды кантип оңой жана тез берсе болот?
          </h3>
          <p className="font-semibold text-sm mb-4">
            Биздин интернет-дүкөндөн эмерек сатып алуу өтө жеңил!
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Каталогдон эмеректи тандаңыз.</li>
            <li>Товарды «+» баскычын басып себетке кошуңуз.</li>
            <li>
              Экрандын жогорку бурчунан себетке кирип, тандоолоруңузду
              текшериңиз.
            </li>
            <li>
              «Заказ берүү» баскычын басып, WhatsApp чатына өтүңүз. Сиздин
              товарыңыз автоматтык түрдө жазылып калат.
            </li>
            <li>Билдирүүнү жөнөтүп, заказды аяктаңыз.</li>
          </ul>
          <h3 className="text-xl font-semibold mb-2">
            Биздин менеджерлер жакынкы убакытта сиз менен байланышып, заказды
            тактап жана жеткирүү күнүн белгилейт.
          </h3>
          <p>📌 Эскертүү:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Заказ даярдоо мөөнөтү: 15-20 күн.</li>
            <li>Региондорго жеткирүү кызматы кошумча төлөнөт.</li>
          </ul>
          <p className=" text-xl">
            Сатып алуу жана кызматтарыбызга кайрылганыңыз үчүн ыраазычылык
            билдиребиз! 😊
          </p>
        </div>
      </div>
    </div>
  );
}

export default PayInfo;
